<template>
  <div class="cookie-settings-dialog">
    <div class="dialog-content">
      <h2>{{ $t("Homepage.cookieSettings") }}</h2>
      <p>{{ $t("Homepage.cookieDescription") }}</p>
      <div class="cookie-options">
        <div v-for="(option, index) in cookieOptions" :key="index" class="cookie-option">
          <label>
            <input type="checkbox" :disabled="option.disabled" v-model="option.enabled" />
            <div class="cookie-label">
              <span>{{ option.label }}</span>
              <span class="cookie-description" style="word-break: break-word">{{ option.description }}</span>
            </div>
          </label>
        </div>
      </div>
      <div class="dialog-actions">
        <button @click="saveSettings">{{$t("Homepage.saveSettingsCooking")}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieSettingsDialog',
  data() {
    return {
      cookieOptions: [
        { 
          label: this.$t("Homepage.necessaryCookies"), 
          enabled: true, 
          disabled: true, 
          description: this.$t("Homepage.necessaryCookiesDescription")
        },
        { 
          label: this.$t("Homepage.performanceCookies"), 
          enabled: JSON.parse(localStorage.getItem('cookiePreferences')).performance, 
          description: this.$t("Homepage.performanceDescription")
        },
        { 
          label: this.$t("Homepage.targetingCookies"), 
          enabled: JSON.parse(localStorage.getItem('cookiePreferences')).targeting, 
          description: this.$t("Homepage.targetingDescription")
        },
      ],
    };
  },
  methods: {
    saveSettings() {
      const preferences = {
        performance: this.cookieOptions[1].enabled,
        targeting: this.cookieOptions[2].enabled,
      };
      localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
      this.$emit('close');  // Close the dialog
      this.applyCookieSettings(preferences);
    },
    applyCookieSettings(preferences) {
      if (!preferences.performance) {
        // Disable analytics (e.g., Google Analytics)
        console.log('Performance cookies disabled');
      } else {
        console.log('Performance cookies enabled');
      }

      if (!preferences.targeting) {
        // Disable targeted ads or tracking services
        console.log('Targeting cookies disabled');
      } else {
        console.log('Targeting cookies enabled');
      }
    },
  },
};
</script>

<style scoped>
.cookie-settings-dialog {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  backdrop-filter: blur(10px);
}

.dialog-content {
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  width: 480px;
  max-width: 90%;
  animation: fadeIn 0.3s ease-in-out;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
}

.dialog-content h2 {
  font-size: 1.75rem;
  color: #1c1c1e;
  margin-bottom: 1.5rem;
  font-weight: 600;
  text-align: center;
}

.dialog-content p {
  font-size: 1rem;
  color: #6e6e73;
  margin-bottom: 2rem;
  text-align: center;
  line-height: 1.6;
}

.cookie-options {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.cookie-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border: 1px solid #d1d1d6;
  border-radius: 12px;
  background: #f9f9f9;
  transition: background-color 0.2s ease;
}

.cookie-option:hover {
  background: #f1f1f1;
}

.cookie-option label {
  font-size: 1rem;
  color: #1c1c1e;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
}

input[type="checkbox"] {
  appearance: none;
  min-width: 20px;
  max-width: 20px;
  height: 20px;
  border: 2px solid #d1d1d6;
  border-radius: 4px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  position: relative;
  cursor: pointer;
}

input[type="checkbox"]:checked {
  background-color: #0a84ff;
  border-color: #0a84ff;
}

input[type="checkbox"]:checked::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

input[type="checkbox"]:disabled {
  background-color: #f2f2f7;
  border-color: #d1d1d6;
  cursor: not-allowed;
  opacity: 0.6;
}

input[type="checkbox"]:checked:disabled {
  background-color: #d1d1d6;
  border-color: #a1a1a6;
}

input[type="checkbox"]:checked:disabled::after {
  border-color: #ffffff99; /* Lightened checkmark */
}


input[type="checkbox"]:disabled::after {
  content: '';
  background: #d1d1d6;
}

.cookie-label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  word-wrap: break-word;
}

.cookie-description {
  font-size: 0.875rem;
  color: #6e6e73;
  margin-top: 0.5rem;
  line-height: 1.4;
  max-height: 5rem; /* Set max height for descriptions */
  overflow-y: auto; /* Allow scrolling if the description overflows */
  text-overflow: ellipsis;
  white-space: normal;
}

.cookie-description.long-description {
  max-height: none; /* Allow longer descriptions to show fully */
  white-space: normal;
  overflow: visible;
}

.dialog-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 2.5rem;
}

.dialog-actions button {
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dialog-actions button:first-child {
  background: #f2f2f7;
  color: #1c1c1e;
}

.dialog-actions button:first-child:hover {
  background: #e5e5ea;
}

.dialog-actions button:last-child {
  background: #0a84ff;
  color: white;
}

.dialog-actions button:last-child:hover {
  background: #0066cc;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


</style>
